import { render, staticRenderFns } from "./RequestJob.vue?vue&type=template&id=245c518e"
import script from "./RequestJob.vue?vue&type=script&lang=js"
export * from "./RequestJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports